import { useSite } from 'Shared/SiteProvider';
import {VenueSettingsFactory} from 'Shared/VenueSettingsFactory';
import { LabelOnLeftWrap } from 'Shared/forms/Wrap';
import { MultiSelect } from 'Shared/forms/Inputs';
import { StylesField } from 'Shared/backend/widgets/Styles';
import { createSignal, Show, Switch, Match } from 'solid-js';
import { css } from '@emotion/css';
import { theme } from 'Shared/ThemeProvider';
import { useVenue } from 'Shared/VenueProvider';


export function StyleTags()
{
	const siteTheme = (new VenueSettingsFactory()).createSettings(useSite().key).siteTheme();

	const venue = useVenue();

	/* Only list styles actually applied at site level — these are what the page can cancel. */
	const siteStyles = () => {
		const ret: Record<string, string> = {};
		for (const s of (venue.styles ?? []) as any[]) {
			const name = s.type ?? s;
			ret[name] = name;
		}
		return ret;
	}

	const classes = () => {
		const ret = {};
		for (const key of siteTheme.classes)
			ret[key] = key;
		return ret;
	}

	const outerStyle = () => css({
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'end',
		marginBottom: '0.7em'
	});

	const paneStyle = () => css({
		width: 500
	});

	const linkWrapStyle = () => css({
		display: 'flex',
	});

	const linkStyle = () => css(theme().a);

	const [show,setShow] = createSignal(false);

//TODO probably trim parent styles and classes to those actually present

	return (
		<div class={outerStyle()}>
			<div class={linkWrapStyle()}>
				<Switch>
					<Match when={show()}>
						<a class={linkStyle()} href='' onClick={() => setShow(false)}>Hide styles</a>
					</Match>
					<Match when={true}>
						<a class={linkStyle()} href='' onClick={() => setShow(true)}>Show styles</a>
					</Match>
				</Switch>
			</div>

			<Show when={show()}>
				<div class={paneStyle()}>
					<LabelOnLeftWrap label='Styles'>
						<StylesField styleDefinitions={siteTheme.styles} />
					</LabelOnLeftWrap>

					<LabelOnLeftWrap label='Classes'>
						<MultiSelect field='classes' options={classes()} />
					</LabelOnLeftWrap>

					<LabelOnLeftWrap label='Parent styles to cancel'>
						<MultiSelect field='removeStyles' options={siteStyles()} />
					</LabelOnLeftWrap>
				</div>
			</Show>
		</div>
	);
}

